import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {SmartCreative} from 'common/src/modules/smartCreative/smartCreative.types';
import {SharePermission} from 'common/src/modules/sharing/sharing.types';
import {SmartCreativesLibraryState} from './smartCreativesLibrary.types';

const smartCreativesLibraryInitialState: SmartCreativesLibraryState = {
  smartCreatives: [],
  sharePermissions: [],
  isPreviewOpen: false,
  selectedSmartCreativeIds: [],
  aiFilter: {
    aiFilteredIds: [],
    query: '',
  },
};

const smartCreativesLibraryReducer = createSlice({
  name: BreadcrumbName.SmartCreativesLibrary,
  initialState: smartCreativesLibraryInitialState,
  reducers: {
    resetState: () => smartCreativesLibraryInitialState,
    setLibraryData: (
      state,
      action: PayloadAction<{smartCreatives: SmartCreative[]; sharePermissions: SharePermission[]}>,
    ) => {
      state.smartCreatives = action.payload.smartCreatives;
      state.sharePermissions = action.payload.sharePermissions;
    },

    closePreview: (state) => {
      state.selectedSmartCreativeIds = [];
      state.isPreviewOpen = false;
    },

    setSelectedSmartCreativeIds: (state, action: PayloadAction<number[]>) => {
      state.selectedSmartCreativeIds = action.payload;
    },

    showPreviewForSmartCreativeId: (state, action: PayloadAction<number>) => {
      state.selectedSmartCreativeIds = [action.payload];
      state.isPreviewOpen = true;
    },

    setAiSmartCreativesFilter: (
      state,
      action: PayloadAction<{aiFilteredIds: number[]; query: string}>,
    ) => {
      state.aiFilter = action.payload;
    },
  },
});

const {
  resetState,
  setLibraryData,
  closePreview,
  setSelectedSmartCreativeIds,
  showPreviewForSmartCreativeId,
  setAiSmartCreativesFilter,
} = smartCreativesLibraryReducer.actions;

export {
  resetState,
  setLibraryData,
  closePreview,
  setSelectedSmartCreativeIds,
  showPreviewForSmartCreativeId,
  setAiSmartCreativesFilter,
};

export default smartCreativesLibraryReducer.reducer;
